// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectSecondary_root__Oa2pr","vLegacy":"SelectSecondary_vLegacy__3xzyB","error":"SelectSecondary_error__88NFi","disabled":"SelectSecondary_disabled__2z-HB"};